import { render, staticRenderFns } from "./recipientBankDetail.vue?vue&type=template&id=4342da7c"
import script from "./recipientBankDetail.vue?vue&type=script&lang=js"
export * from "./recipientBankDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports